module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/front/decoration_buildings-4465d96113bbee657e4fc204dfdcaa72.png";